#import "../fragments/edition-stub-fragment.graphql"

query GetEditionsForPreviewList(
    $first: Int!
    $after: String
    $sort: EditionSortType
    $audienceId: ID
    $campaignTypes: [CampaignType!]
    $statuses: [EditionStatus!]
) {
    editions(
        first: $first
        after: $after
        audienceId: $audienceId
        campaignTypes: $campaignTypes
        statuses: $statuses
        sort: $sort
    ) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...EditionStub
            }
        }
    }
}
